import { Injectable } from '@angular/core';
import { SettingsMasterService } from './masters/settings-master.service';

@Injectable({
  providedIn: 'root',
})
export class MastersService {
  constructor(
    public readonly settings: SettingsMasterService,
  ) {}
}
